<button class="link-button" [class.block]="pageContent.PageContentTypeName == 'Sidebar Link Button'" (click)="linkButtonClicked(url)">
    {{title}}<img alt="external link" src="assets/images/external-link-blue.svg" [alt]="title">
</button>